import Hero from "@/components/Hero";
import FeaturedProducts from "@/components/FeaturedProducts";
import ProductSlider from "@/components/ProductSlider";
import About from "@/components/About";
import Services from "@/components/Services";
import Leadership from "@/components/Leadership";
import ClientsCarousel from "@/components/ClientsCarousel";
import WhyChooseUs from "@/components/WhyChooseUs";
import Contact from "@/components/Contact";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <FeaturedProducts />
      <ProductSlider />
      <About />
      <Services />
      <Leadership />
      <ClientsCarousel />
      <WhyChooseUs />
      <Contact />
    </div>
  );
}
